import PercentBadge from 'Images/svg/percent-badge.svg';
import { Popover } from 'antd';
import ServiceProviderDiscountRulesTable from '../ServiceProviderDiscountRulesTable';
import ServiceProviderAvatarWithName from '../ServiceProviderAvatarWithName';
import { DiscountRulesForServiceProvider } from 'Common/functions/getDiscountRulesForServiceProvider';
import ChevronDown from 'Images/svg/chevron-down.svg';

type discountRule = Pick<DiscountRulesForServiceProvider[number], 'discountValue' | 'triggerCondition' | 'discountType'>

type DiscountRulesDetailsPopoverProps = {
  serviceProviderDisplayName: string;
  serviceProviderAvatarImageUrl: string | null | undefined;
  discountRules: discountRule[];
  mode?: 'button' | 'arrow';
}

const DiscountRulesDetailsPopover: React.FC<DiscountRulesDetailsPopoverProps> = ({
  serviceProviderDisplayName,
  serviceProviderAvatarImageUrl,
  discountRules,
  mode = 'button',
}) => {
  const content = (
    <div className="flex gap-2">
      <PercentBadge
        style={{
          minWidth: mode === 'button' ? '18px' : '12px',
        }}
      />
      <div className="flex flex-wrap gap-1">
        <span className="text-left">
          Discount
        </span>
        <span className="text-left">
          Details
        </span>
      </div>
    </div>
  );

  return discountRules && discountRules.length > 0 && (
    <Popover
      title={(
        <div>
          <ServiceProviderAvatarWithName
            serviceProviderAvatarImageUrl={serviceProviderAvatarImageUrl}
            displayName={serviceProviderDisplayName}
            prefix={(
              <span className="uppercase text-primary">
                Discount Details
              </span>
            )}
          />
        </div>
      )}
      content={(
        <div className="lg:min-w-96 lg:p-4 max-w-48 lg:max-w-96">
          <ServiceProviderDiscountRulesTable
            discountRules={discountRules}
            serviceProviderDisplayName={serviceProviderDisplayName}
          />
        </div>
      )}
    >
      {mode === 'button' ? (
        <button
          className="border-gray-200 border-solid border-2 items-center py-2 sm:px-2 bg-white rounded-md sm:text-sm lg:text-base uppercase w-full lg:w-auto"
          type="button"
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {content}
        </button>
      ) : (
        <div className="flex items-center gap-6 cursor-pointer">
          {content}
          <ChevronDown className="stroke-black" />
        </div>
      )}
    </Popover>
  );
};

export default DiscountRulesDetailsPopover;
